export default [
  {
    path: '/properties',
    name: 'PropertiesList',
    component: () => import('pages/properties/list/PropertiesList.vue')
  },
  {
    path: '/properties/:id',
    name: 'PropertiesSingleLayout',
    component: () => import('pages/properties/single/_layouts/PropertiesSingleLayout.vue'),
    redirect: { name: 'PropertiesInfoSingle' },
    children: [
      {
        path: '/properties/:id/info',
        name: 'PropertiesInfoSingle',
        component: () => import('pages/properties/single/tabs/info/PropertiesInfoSingle.vue'),
        meta: { slug: 'info' }
      },
      {
        path: '/properties/:id/medias',
        name: 'PropertiesMediasList',
        component: () => import('pages/properties/single/tabs/PropertiesMediasList.vue'),
        meta: { slug: 'medias' }
      },
      {
        path: '/properties/:id/documents',
        name: 'PropertiesDocumentsList',
        component: () => import('pages/properties/single/tabs/PropertiesDocumentsList.vue'),
        meta: { slug: 'documents' }
      },
      {
        path: '/properties/:id/interests',
        name: 'PropertiesInterestsList',
        component: () => import('pages/properties/single/tabs/interests/PropertiesInterestsList.vue'),
        meta: { slug: 'interests' }
      }
    ]
  },
  {
    path: '/properties/:id/sales/new',
    name: 'PropertiesSalesCreate',
    component: () => import('pages/property-sales/create/PropertySalesCreate.vue')
  },
  {
    path: '/properties/:id/interests/new',
    name: 'PropertiesInterestsCreate',
    component: () => import('pages/properties/single/tabs/interests/PropertiesInterestsCreate.vue')
  }
]
